import { useState, type FormEvent } from 'react'
import { AppBrand } from './AppBrand'

export function LoginView({ onLogin }: { onLogin: (username: string, password: string) => Promise<void> }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string>()
  const [submitting, setSubmitting] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (!username.trim() || !password) return
    setSubmitting(true)
    setError(undefined)
    try {
      await onLogin(username.trim(), password)
    } catch (value) {
      setError(value instanceof Error ? value.message : 'Не удалось выполнить вход')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="login-page">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="login-brand"><AppBrand tagline /></div>
        <p className="eyebrow">Защищённый контур</p>
        <h1 id="login-title">Вход в систему</h1>
        <p className="login-copy">Мониторинг нагрузки и целостности упаковки при транспортировке.</p>
        <form onSubmit={submit}>
          <label><span>Логин</span><input value={username} onChange={event => setUsername(event.target.value)} autoComplete="username" autoCapitalize="none" spellCheck={false} autoFocus required /></label>
          <div className="login-field">
            <label htmlFor="login-password">Пароль</label>
            <div className="login-password-field">
              <input id="login-password" type={passwordVisible ? 'text' : 'password'} value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" required />
              <button type="button" aria-label={passwordVisible ? 'Скрыть пароль' : 'Показать пароль'} aria-pressed={passwordVisible} onClick={() => setPasswordVisible(value => !value)}>
                <PasswordVisibilityIcon visible={passwordVisible} />
              </button>
            </div>
          </div>
          {error && <div className="login-error" role="alert">{error}</div>}
          <button className="button primary" type="submit" disabled={submitting || !username.trim() || !password}>{submitting ? 'Выполняется вход…' : 'Войти'}</button>
        </form>
        <small className="login-security">Сессия хранится в защищённой HttpOnly-cookie. Пароль не сохраняется в браузере.</small>
      </section>
      <aside className="login-visual" aria-hidden="true"><div><i /><i /><i /><i /><span>Контроль давления<br />на каждом углу паллеты</span></div></aside>
    </main>
  )
}

function PasswordVisibilityIcon({ visible }: { visible: boolean }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M2.75 12s3.4-5 9.25-5 9.25 5 9.25 5-3.4 5-9.25 5S2.75 12 2.75 12Z" />
      <circle cx="12" cy="12" r="2.25" />
      {visible && <path d="m4 4 16 16" />}
    </svg>
  )
}
